import { FC } from 'react';

import OperationsSectionHeader from './OperationsSectionHeader';
import OperationsSectionBody from './OperationsSectionBody';

const OperationsSection: FC = () => (
  <>
    <OperationsSectionHeader />
    <OperationsSectionBody />
  </>
);

export default OperationsSection;
